export enum RessourcesActionsTypes {
  GET_RESSOURCES_SUCCESS = 'GET_RESSOURCES_SUCCESS',
  GET_RESSOURCES_FAILED = 'GET_RESSOURCES_FAILED',
  GET_RESSOURCES_REQUEST = 'GET_RESSOURCES_REQUEST',
  RESET_RESSOURCES = 'RESET_RESSOURCES',
}
